import { Parser as BinaryParser } from 'binary-parser';
import type { IpHeader } from './types';

export * from './types';

const ipHeader = new BinaryParser()
  .endianness('big')
  .bit4('version')
  .bit4('headerLength')
  .uint8('tos')
  .uint16('length')
  .uint16('identification')
  .bit3('offset')
  .bit13('fragmentOffset')
  .uint8('ttl')
  .uint8('protocol')
  .uint16('checksum')
  .array('src', {
    type: 'uint8',
    length: 4,
  })
  .array('dst', {
    type: 'uint8',
    length: 4,
  })
  .buffer('data', {
    readUntil: 'eof',
  });

function ipParser(buffer: Buffer): IpHeader {
  const parsed: IpHeader = ipHeader.parse(buffer);
  parsed.sourceIp = parsed.src.join('.');
  parsed.destinationIp = parsed.dst.join('.');

  return parsed;
}

export default ipParser;
